import { render, staticRenderFns } from "./JettonWallet.vue?vue&type=template&id=10a63104"
import script from "./JettonWallet.vue?vue&type=script&lang=js"
export * from "./JettonWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports